import { createProvideInject } from '@collector/shared-ui'

import { LineupConfig } from '../configuration'

export const [provideLineupConfig, injectLineupConfig] =
  createProvideInject<LineupConfig>('lineupConfig')
